import React, { useEffect, useState } from "react";
import { ModalCrosSvg, ParticipantSvg } from "../../../images/Svgs";
import { toast } from "react-toastify";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import {
  Addroutine,
  getEventMasterList,
  getCountEntry,
  getAllEvents,
} from "../../../API/routine";
import { useParams } from "react-router-dom";
import { currentDate } from "../../../utils/common";
import CustomDropdown from "../../../components/CustomDropdown";

const initionalEvent = {
  event_id: "",
  event_date: "",
  event_time_from: "",
  event_time_to: "",
  entry_title: "",
  title: "",
  entry: "",
  entry_age: "",
  performers: "",
  entry_division: "",
  age_class: "",
  level: "",
  music_category: "",
  studio_name: "",
  studio_code: "",
  props: false,
  starts: false,
  performersList: [],
  event_schedule_id: "",
  type: "",
  ceremony: 0,
  notes: "",
};

const AddRoutine = ({ onSetModal, editRoutine = {}, eventList }) => {
  const [eventData, setEventData] = useState(initionalEvent);
  const [EventMasterList, setEventMasterList] = useState([]);
  const [EventList, setEventList] = useState([]);
  const [showFields, setShowFields] = useState(false);
  const EventID = useParams();
  const [fields, setFields] = useState([]);
  const [studioList, setStudioList] = useState([]);
  const [studioNames, setStudioNames] = useState([]);
  const [studioCodes, setStudioCodes] = useState([]);
  const [entryList, setEntryList] = useState([]);
  const [eventError, setEventError] = useState({
    event_date: "",
    event_time_from: "",
    event_time_to: "",
    type: "",
    entry_title: "",
    ceremony: "",
    // performers : {},
    performers : [],
  });
useEffect(() => {
  const list = eventList?.eventSchedule; // ✅ FIX HERE
  if (!Array.isArray(list) || list.length === 0) return;
  const uniqueMap = new Map();
  const entrySet = new Set();
  list.forEach((item) => {
    if (item.studio_name && item.studio_code) {
      const key = `${item.studio_name}-${item.studio_code}`;

      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, {
          studio_name: item.studio_name,
          studio_code: item.studio_code,
        });
      }
    }
     // entry dropdown values
    if (
      item.revised_entry !== null &&
      item.revised_entry !== undefined &&
      item.revised_entry !== ""
    ) {
      entrySet.add(item.revised_entry);
    }
  });
  const uniqueList = Array.from(uniqueMap.values());
  setStudioList(uniqueList);
  setStudioNames([...new Set(uniqueList.map(i => i.studio_name))]);
  setStudioCodes([...new Set(uniqueList.map(i => i.studio_code))]);
  // entry dropdown
  setEntryList([...entrySet]);

}, [eventList]);
const filteredCodes = studioList.filter(item =>item.studio_name &&item.studio_code &&item.studio_name === eventData?.studio_name).map(item => item.studio_code);
const filteredNames = studioList.filter(item =>item.studio_name &&item.studio_code &&item.studio_code === eventData?.studio_code ).map(item => item.studio_name);
  useEffect(() => {
    if (editRoutine && Object.keys(editRoutine).length > 0) {
      // setShowFields(editRoutine?.type === "routine");
      setShowFields( editRoutine?.type === "routine" ||(editRoutine?.entry && editRoutine.entry.trim() !== ""));
      setEventData((prevData) => ({
        ...initionalEvent,
        ...editRoutine,
         type:
        editRoutine?.entry && editRoutine.entry.trim() !== ""
          ? "routine"
          : editRoutine?.type, //simple condition
        event_schedule_id: editRoutine.id,
        performersList: editRoutine.eventPerformer
          ? editRoutine.eventPerformer.map((p) => p.performer_name)
          : [],
      }));
      if (editRoutine.performers) {
        handleFieldCountChange(parseInt(editRoutine.performers));
      }
      if (editRoutine.eventPerformer) {
        setFields(
          editRoutine.eventPerformer.map(
            (performer) => performer.performer_name
          )
        );
      }
    }
  }, [editRoutine]);

  // const handleFieldCountChange = (count) => {
  //   const numberOfFields = Math.max(1, parseInt(count, 10) || 0);
  //   const updatedFields = Array.from(
  //     { length: numberOfFields },
  //     (_, index) => fields[index] || ""
  //   );
  //   setFields(updatedFields);
  // };

  const handleFieldCountChange = (count) => {
     //Ignore empty input (important fix)
    if (!count || isNaN(count)) return;
    const numberOfFields = Math.max(1, parseInt(count, 10) || 0);

    setFields((prevFields) => {
      let updatedFields = [...prevFields];

      if (numberOfFields > updatedFields.length) {
        // Add new empty fields
        updatedFields = [
          ...updatedFields,
          ...Array(numberOfFields - updatedFields.length).fill("")
        ];
      } else {
        // Remove extra fields
        updatedFields = updatedFields.slice(0, numberOfFields);
      }

      // ✅ Sync with eventData
      setEventData((prevData) => ({
        ...prevData,
        performersList: updatedFields,
      }));

      return updatedFields;
    });
  };

  // const handlePerformanceChange = (index, value) => {
  //   const updatedFields = [...fields];
  //   updatedFields[index] = value;
  //   //remove error for this field when user types
  //   setEventError((prev) => {
  //     const newErrors = { ...prev };

  //     if (newErrors.performers) {
  //       newErrors.performers = [...newErrors.performers];
  //       newErrors.performers[index] = "";
  //     }

  //     return newErrors;
  //   });

  //   setEventData((prevData) => ({
  //     ...prevData,
  //     performersList: updatedFields,
  //   }));
  //   setFields(updatedFields);
  // };

  const handlePerformanceChange = (index, value) => {
    const updatedFields = Array.isArray(fields) ? [...fields] : [];
    updatedFields[index] = value;

    // remove error for this field when user types
    setEventError((prev) => {
      const newErrors = { ...prev };

      if (Array.isArray(newErrors.performers)) {
        newErrors.performers = [...newErrors.performers];
        newErrors.performers[index] = "";
      } else {
        newErrors.performers = [];
      }

      return newErrors;
    });

    setEventData((prevData) => ({
      ...prevData,
      performersList: updatedFields,
    }));

    setFields(updatedFields);
  };

  const validateForm = () => {
    let errors = {};
    let isValid = true;

    if (!eventData?.event_date) {
      errors.event_date = "Start date is required.";
      isValid = false;
    }
    // if (!eventData?.event_time_to) {
    //   errors.event_time_to = "To time is required.";
    //   isValid = false;
    // }
    if (!eventData?.event_time_from) {
      errors.event_time_from = "From time is required.";
      isValid = false;
    }
    if (!eventData?.type) {
      errors.type = "Routine type is required.";
      isValid = false;
    }
    if (!eventData?.entry_title) {
      errors.entry_title = "Entry title is required.";
      isValid = false;
    }
    if (eventData?.ceremony == 0 && eventData?.type === "routine") {
      errors.ceremony = "Ceremony is required.";
      isValid = false;
    }
    // ✅ NEW: Performers validation
    if (fields && fields.length > 0) {
      const performerErrors = fields.map((field, index) => {
        if (!field || field.trim() === "") {
          isValid = false;
          return `Performer ${index + 1} is required`;
        }
        return "";
      });

      errors.performers = performerErrors;
    }

    //ADD THIS BLOCK HERE
    // if (!eventData?.performers || eventData.performers === 0) {
    //   setEventData((prev) => ({
    //     ...prev,
    //     performers: fields.length, 
    //   }));
    // }
    setEventError(errors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setEventData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  
    if (name === "performers") {
      handleFieldCountChange(Number(value));
    }
  
    if (eventError[name]) {
      setEventError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }
  
    if (name === "type") {
      setShowFields(value === "routine");
      
      setEventError({
        event_date: "",
        event_time_from: "",
        event_time_to: "",
        type: "",
        entry_title: "",
        ceremony: "",
      });
    }
  };

  useEffect(() => {
    const getData = async () => {
      const data = await getEventMasterList();
      const EntryData = await getCountEntry();
      const EventData = await getAllEvents();

      setEventMasterList(data?.data);
      setEventList(EventData?.data?.events);
      setEventData((prevData) => ({
        ...prevData,
        // entry: EntryData?.data?.countEntry + 1,
        event_id: EventID?.id,
      }));
    };
    getData();
  }, [EventID]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        //let payload = { ...eventData };
         let payload = {
        ...eventData,
        performers:
          eventData?.performers && eventData.performers !== 0
            ? eventData.performers
            : fields.length,
      };
        payload.starts = 0;
        payload.props =
          payload.props === true || payload.props === 1 ? true : false;
        payload.title = "x";
        if (editRoutine?.length < 1) {
          payload.event_schedule_id = "";
        }
        if (payload.type !== "routine") {
          payload.title = "";
          payload.entry_age = "";
          payload.performers = "";
          payload.entry_division = "";
          payload.age_class = "";
          payload.level = "";
          payload.music_category = "";
          payload.studio_name = "";
          payload.studio_code = "";
          payload.performersList = [];
        } else {
          payload.performersList = fields;
        }
        delete payload.eventPerformer;
        delete payload.id;
        const response = await Addroutine(payload);
        if (response?.status) {
          toast.success(response.message || "Success!");
          onSetModal(false);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error during request:", error);
      }
    } else {
      console.log("Form has errors.");
    }
  };

  return (
    <div className="modal fade show">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              {editRoutine && Object.keys(editRoutine).length > 0
                ? "Edit Routine"
                : "Add Routine"}
            </h5>
            <button
              type="button"
              className="close"
              onClick={() => onSetModal(false)}
            >
              <ModalCrosSvg />
            </button>
          </div>
          <div className="modal-body">
            <div className="routine_form">
              <form id="eventForm" noValidate onSubmit={(e) => handleSubmit(e)}>
                <div className="mb-3">
                  <div className="row">
                    <div className="col-md-6">
                      <select
                        className="form-select"
                        id="timeFrom"
                        name="event_id"
                        value={eventData?.event_id}
                        onChange={(e) => handleChange(e)}
                        disabled
                      >
                        <option value="">Select Entry Division</option>
                        {EventList &&
                          EventList?.map((ele) => (
                            <option key={ele?.id} value={ele?.id}>
                              {ele?.event_title}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-6">
                      <div className="col">
                        <select
                          className="form-select"
                          id="timeTo"
                          name="type"
                          value={eventData?.type}
                          onChange={(e) => {
                            handleChange(e);
                            setShowFields(e.target.value === "routine");
                          }}
                        >
                          <option value="">Select type</option>
                          <option value="awards">Awards</option>
                          <option value="break">Break</option>
                          <option value="routine">Routine</option>
                          <option value="openDoor">Open Door</option>
                        </select>
                        {eventError.type && (
                          <div className="text-danger">{eventError.type}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <div className="date_time_section">
                    <div className="date_lable">
                      <label className="form-label d-flex align-items-center">
                        <svg
                          className="me-2"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                          <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
                        </svg>
                        Date & Time
                      </label>
                    </div>
                    <hr />
                    <div className="date_contant">
                      <div className="row">
                        <div className="col-md-6">
                          <label className="form-label d-flex align-items-center">
                            Entry Title
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Entry Title"
                            name="entry_title"
                            value={eventData?.entry_title}
                            onChange={(e) => handleChange(e)}
                          />
                          {eventError.entry_title && (
                            <div className="text-danger">
                              {eventError.entry_title}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6">
                          <label className="form-label d-flex align-items-center">
                            Event date
                          </label>
                          <Flatpickr
                            options={{
                              dateFormat: "Y-m-d",
                              minDate: eventList?.event_date,
                              maxDate: eventList?.event_end_date,
                              static: true,
                            }}
                            value={eventData?.event_date || ""}
                            onChange={(selectedDates, dateStr) => {
                              setEventData({
                                ...eventData,
                                event_date: dateStr,
                              });
                            }}
                            render={({ defaultValue, value, ...props }, ref) => (
                              <input
                                {...props}
                                ref={ref}
                                type="text"
                                placeholder="Choose date"
                                className="form-control"
                              />
                            )}
                          />

                          {eventError.event_date && (
                            <div className="text-danger">
                              {eventError.event_date}
                            </div>
                          )}
                          {/* <input
                            type="date"
                            className="form-control"
                            id="eventStartDate"
                            title="Choose date"
                            name="event_date"
                            // max="9999-12-31"
                            min={eventList?.event_date}
                            max={eventList?.event_end_date}
                            value={eventData?.event_date}
                            onChange={(e) => handleChange(e)}
                          />
                          {eventError.event_date && (
                            <div className="text-danger">
                              {eventError.event_date}
                            </div>
                          )} */}
                        </div>
                      </div>
                      {/* <div className="row">
                        <div className="col">
                          <label className="form-label d-flex align-items-center">
                            From
                          </label>
                          <input
                            type="time"
                            className="form-control mb-2"
                            id="eventEndDate"
                            title="Choose end date"
                            name="event_time_from"
                            value={eventData?.event_time_from}
                            onChange={(e) => handleChange(e)}
                          />
                          {eventError.event_time_from && (
                            <div className="text-danger">
                              {eventError.event_time_from}
                            </div>
                          )}
                        </div>
                        <div className="col">
                          <label className="form-label d-flex align-items-center">
                            To
                          </label>
                          <input
                            type="time"
                            className="form-control mb-2"
                            id="eventEndDate"
                            name="event_time_to"
                            value={eventData?.event_time_to}
                            onChange={(e) => handleChange(e)}
                          />
                          {eventError.event_time_to && (
                            <div className="text-danger">
                              {eventError.event_time_to}
                            </div>
                          )}
                        </div>
                      </div> */}
                      <div className="row">
                        {/* From Time */}
                        <div className="col">
                          <label className="form-label d-flex align-items-center">
                            From
                          </label>

                          <Flatpickr
                            options={{
                              enableTime: true,
                              noCalendar: true,
                              dateFormat: "h:i K", // 12-hour with AM/PM
                              static: true,
                            }}
                            value={eventData?.event_time_from || ""}
                            onChange={(selectedDates, dateStr) => {
                              setEventData({
                                ...eventData,
                                event_time_from: dateStr,
                              });
                            }}
                            render={({ defaultValue, value, ...props }, ref) => (
                              <input
                                {...props}
                                ref={ref}
                                type="text"
                                placeholder="Select from time"
                                className="form-control mb-2"
                              />
                            )}
                          />

                          {eventError.event_time_from && (
                            <div className="text-danger">
                              {eventError.event_time_from}
                            </div>
                          )}
                        </div>

                        {/* To Time */}
                        <div className="col">
                          <label className="form-label d-flex align-items-center">
                            To
                          </label>

                          <Flatpickr
                            options={{
                              enableTime: true,
                              noCalendar: true,
                              dateFormat: "h:i K",
                              static: true,
                            }}
                            value={eventData?.event_time_to || ""}
                            onChange={(selectedDates, dateStr) => {
                              setEventData({
                                ...eventData,
                                event_time_to: dateStr,
                              });
                            }}
                            render={({ defaultValue, value, ...props }, ref) => (
                              <input
                                {...props}
                                ref={ref}
                                type="text"
                                placeholder="Select to time"
                                className="form-control mb-2"
                              />
                            )}
                          />

                          {eventError.event_time_to && (
                            <div className="text-danger">
                              {eventError.event_time_to}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          {showFields && (
                            <>
                              <label className="form-label d-flex align-items-center">
                                Ceremony
                              </label>
                              <CustomDropdown
                                id="ceremony"
                                name="ceremony"
                                value={eventData?.ceremony}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              />
                              {eventError.ceremony && (
                                <div className="text-danger">
                                  {eventError.ceremony}
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {showFields && (
                  <div className="mb-3">
                    <div className="date_lable details_icon">
                      <label className="form-label d-flex align-items-center">
                        <ParticipantSvg />{" "}
                        <span style={{ marginLeft: "10px" }}>
                          Participant Details
                        </span>
                      </label>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col mb-6">
                        <label className="form-label d-flex align-items-center">
                          Title
                        </label>
                        <select
                          className="form-select"
                          id="timeFrom"
                          name="title"
                          value="x"
                          onChange={(e) => handleChange(e)}
                        >
                          <option value="x">X</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label d-flex align-items-center">
                          Entry #
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Entry #"
                          name="entry"
                          value={eventData?.entry || ""}
                          onChange={(e) => {
                            const value = e.target.value;

                            // Allow empty, integer, and decimal values
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              handleChange(e);
                            }
                          }}
                          onKeyDown={(e) => {
                            // Prevent multiple decimal points
                            if (
                              e.key === "." &&
                              e.currentTarget.value.includes(".")
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                      {/* <div className="col-md-6">
                        <label className="form-label d-flex align-items-center">
                          Entry #
                        </label>

                         <select
                            className="form-control"
                            name="entry"
                            value={eventData?.entry || ""}
                            onChange={handleChange}
                          >
                          <option value="">Select Entry</option>

                          {entryList.map((entry, index) => (
                            <option key={index} value={entry}>
                              {entry}
                            </option>
                          ))}
                        </select>
                      </div> */}
                      {/* <div className="col-md-6">
                        <label className="form-label d-flex align-items-center">
                          Entry #
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Entry"
                          name="entry"
                          value={eventData?.entry}
                          onChange={(e) => {
                            const value = e.target.value;
                              // if (value === "" || /^[1-9]\d*$/.test(value)) {
                              //   handleChange(e);
                              // }
                              if (value === "" || /^\d*\.?\d*$/.test(value)) {
                                handleChange(e);
                              }
                          }}
                          onKeyPress={(e) => {
                            const char = String.fromCharCode(e.charCode);
                            const currentValue = e.target.value;

                            if (!/[0-9.]/.test(char)) {
                              e.preventDefault();
                              return;
                            }

                            // prevent multiple decimals
                            if (char === "." && currentValue.includes(".")) {
                              e.preventDefault();
                            }
                          }}
                          // onKeyPress={(e) => {
                          //   const char = String.fromCharCode(e.charCode);
                          //   const currentValue = e.target.value;
                          //   const cursorPosition = e.target.selectionStart;
                          //   if (!/\d/.test(char)) {
                          //     e.preventDefault();
                          //     return;
                          //   }
                          //   if (
                          //     (currentValue === "" || cursorPosition === 0) &&
                          //     char === "0"
                          //   ) {
                          //     e.preventDefault();
                          //     return;
                          //   }
                          // }}
                        />
                      </div> */}
                    </div>
                    <div className="row mt-3">
                      <div className="col mb-3">
                        <label className="form-label d-flex align-items-center">
                          Entry Age
                        </label>
                        <select
                          className="form-select"
                          id="timeFrom"
                          name="entry_age"
                          value={parseInt(eventData?.entry_age)}
                          onChange={(e) => handleChange(e)}
                        >
                          <option value="">Select Age</option>
                          {Array.from({ length: 20 }, (_, i) => i + 1).map(
                            (num) => (
                              <option key={num} value={num}>
                                {num}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                      <div className="col mb-3">
                        <label className="form-label d-flex align-items-center">
                          Performers
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Performers"
                          name="performers"
                          value={eventData?.performers}
                          onChange={(e) => {
                            const value = Number(e.target.value);
                            if (value <= 100) {
                              handleChange(e);
                              handleFieldCountChange(value);
                            }
                          }}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onPaste={(e) => e.preventDefault()}
                          max={100}
                          // disabled={eventData?.event_schedule_id}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col mb-3">
                        <label className="form-label d-flex align-items-center">
                          Entry Division
                        </label>
                        <select
                          className="form-select"
                          id="timeFrom"
                          name="entry_division"
                          value={eventData?.entry_division}
                          onChange={(e) => handleChange(e)}
                        >
                          <option value="">Select Entry Division</option>
                          {EventMasterList?.entryDivision &&
                            EventMasterList?.entryDivision?.map((division) => (
                              <option key={division?.id} value={division?.id}>
                                {division?.name}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="col mb-3">
                        <label className="form-label d-flex align-items-center">
                          Age Class
                        </label>
                        <select
                          className="form-select"
                          id="timeFrom"
                          name="age_class"
                          value={eventData?.age_class}
                          onChange={(e) => handleChange(e)}
                        >
                          <option value="">Select Age Class</option>
                          {EventMasterList?.ageClass &&
                            EventMasterList?.ageClass?.map((ageClass) => (
                              <option key={ageClass?.id} value={ageClass?.id}>
                                {ageClass?.name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col mb-3">
                        <label className="form-label d-flex align-items-center">
                          Level
                        </label>
                        <select
                          className="form-select"
                          id="timeFrom"
                          name="level"
                          value={eventData?.level}
                          onChange={(e) => handleChange(e)}
                        >
                          <option value="">Select Level</option>
                          {EventMasterList?.levels &&
                            EventMasterList?.levels?.map((level) => (
                              <option key={level?.id} value={level?.id}>
                                {level?.name}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="col mb-3">
                        <label className="form-label d-flex align-items-center">
                          Music Category
                        </label>
                        <select
                          className="form-select"
                          id="timeFrom"
                          name="music_category"
                          value={eventData?.music_category}
                          onChange={(e) => handleChange(e)}
                        >
                          <option value="">Select Music Category</option>
                          {EventMasterList?.musicCategory &&
                            EventMasterList?.musicCategory?.map((music) => (
                              <option key={music?.id} value={music?.id}>
                                {music?.name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="row">
                      {/* Studio Name Dropdown */}
                      <div className="col mb-3">
                        <label className="form-label">Studio Name</label>
                        <select
                          className="form-control"
                          value={eventData?.studio_name || ""}
                          onChange={(e) => {
                            setEventData((prev) => ({
                              ...prev,
                              studio_name: e.target.value,
                            }));
                          }}
                        >
                          <option value="">Select Studio Name</option>
                          {studioNames.map((name, index) => (
                            <option key={index} value={name}>
                              {name}
                            </option>
                          ))}
                        </select>
                      </div>
                      {/* Studio Code Dropdown */}
                      <div className="col mb-3">
                        <label className="form-label">Studio Code</label>
                        <select
                          className="form-control"
                          value={eventData?.studio_code || ""}
                          onChange={(e) => {
                            setEventData((prev) => ({
                              ...prev,
                              studio_code: e.target.value,
                            }));
                          }}
                        >
                          <option value="">Select Studio Code</option>
                          {studioCodes.map((code, index) => (
                            <option key={index} value={code}>
                              {code}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {/* <div className="row">
                      <div className="col mb-3">
                        <label className="form-label d-flex align-items-center">
                          Studio Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Studio Name"
                          name="studio_name"
                          value={eventData?.studio_name}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                      <div className="col mb-3">
                        <label className="form-label d-flex align-items-center">
                          Studio Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Studio Code"
                          name="studio_code"
                          value={eventData?.studio_code}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div> */}
                    <div className="row">
                      <div className="col mb-3">
                        <label className="form-label d-flex align-items-center">
                          Notes
                        </label>
                        <textarea
                          className="form-control"
                          placeholder="Enter Notes"
                          name="notes"
                          value={eventData?.notes}
                          onChange={(e) => handleChange(e)}
                          rows={3}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col mb-3 routine_box">
                        <span className="">Props</span>
                        <input
                          type="checkbox"
                          name="props"
                          checked={eventData.props}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                      {/* <div className="col mb-3  routine_box">
                        <span className="">On/Off</span>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="starts"
                            id={`flexSwitchCheckDefault-on_off`}
                            checked={eventData?.starts}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                      </div> */}
                    </div>
                    {/* <div className="row">
                      <div className="col mb-3">
                        <label className="form-label d-flex align-items-center">
                          Performer
                        </label>
                        {fields.map((field, index) => (
                          <React.Fragment key={index}>
                            <input
                              type="text"
                              className="form-control mb-2"
                              placeholder={`Performer ${index + 1}`}
                              name={`performer_${index + 1}`}
                              value={field}
                              onChange={(e) =>
                                handlePerformanceChange(index, e.target.value)
                              }
                            />
                            {eventError?.performers?.[index] && (
                              <div className="text-danger mb-2">
                                {eventError?.performers?.[index]}
                              </div>
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    </div> */}
                    <div className="row">
                      <div className="col mb-3">
                        <label className="form-label d-flex align-items-center">
                          Performer
                        </label>

                        {(Array.isArray(fields) ? fields : []).map((field, index) => (
                          <React.Fragment key={index}>
                            <input
                              type="text"
                              className="form-control mb-2"
                              placeholder={`Performer ${index + 1}`}
                              name={`performer_${index + 1}`}
                              value={field || ""}
                              onChange={(e) =>
                                handlePerformanceChange(index, e.target.value)
                              }
                            />

                            {eventError?.performers?.[index] && (
                              <div className="text-danger mb-2">
                                {eventError.performers[index]}
                              </div>
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => onSetModal(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-dark">
                    {Object.keys(editRoutine).length > 0 ? "Update" : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddRoutine;
